import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Auth from '@/auth/Auth'
import Eventos from '@/views/Eventos'
import Agenda from '@/views/Agenda'
import Inscricoes from '@/views/Inscricoes'
import Dispositivos from '@/views/Dispositivos'
import About from '@/views/About'
import Login from '@/auth/Login'
import Vigilantes from '@/views/Vigilantes'
import Convocacao from '@/views/Convocacao'
import AssociarQRCode from '@/views/AssociarQRCode'
import CriaQRCode from '@/views/CriaQRCode'
import AssociarQRCodeeCheckin from '@/views/AssociarQRCodeeCheckin'
import Divulgador from '@/views/Divulgador'
import ListaIndicacoes from '@/views/ListaIndicacoes'
import Transacoes from '@/views/Transacoes'
import IgrejadaLiberdade from '@/views/Pages/IgrejadaLiberdade'
import RelRede from '@/views/RelRede'
import RelCelula from '@/views/RelCelula'
import RelMembros from '@/views/RelMembros'
import RelLiderRede from '@/views/RelLiderRede'
import RelSupervisor from '@/views/RelSupervisor'
import RelLiderCelula from '@/views/RelLiderCelula'
import RelMembrosKids from '@/views/RelMembrosKids'
import RelMinisterios from '@/views/RelMinisterios'
import LiberdadeEB from '@/views/Pages/LiberdadeEB'
import LinksLiberdade from '@/views/Pages/LinksLiberdade'
import Voluntario from '@/views/Pages/Voluntario'
import Voluntarios from '@/views/Voluntarios'
import LiberdadeEM from '@/views/Pages/LiberdadeEM'
import CadastroProfissionais from '@/views/Pages/CadastroProfissionais'
import CatalogoProfissionais from '@/views/Pages/CatalogoProfissionais'
import IL from '@/views/Pages/IL'
import ILKids from '@/views/Pages/ILKids'
import MembroTurma from '@/views/MembroTurma'
import Programa from '@/views/Programa'
import Beneficiario from '@/views/Beneficiario'
import CheckinMembroTurma from '@/views/Pages/CheckinMembroTurma'
import ILEBKids from '@/views/Pages/ILEBKids'
import EscolaBiblica from '@/views/EscolaBiblica'
// import ILEDKids from '@/views/Pages/ILEDKids'
import EncontroComDeus from '@/views/EncontroComDeus'
import RelTurma from '@/views/RelTurma'
import { userKey } from '@/global'
import LiberdadeSocial from '../views/Pages/LiberdadeSocial.vue'
import Igrejas from '../views/Igrejas.vue'
import liberdadeRCad from '@/views/Pages/liberdadeRCad'
import RelProfissionais from '@/views/RelProfissionais'
import Servicos from '@/views/Servicos'
import Historico from '@/views/Historico'
import Auditoria from '@/views/Auditoria'
import Landing from '@/views/Pages/Landing'
import CriarConta from '@/views/Pages/CriarConta'
import CadastroMembro from '@/views/Pages/CadastroMembro'
import LinksIgreja from '@/views/Pages/LinksIgreja'
import MinhaIgreja from '@/views/MinhaIgreja'
import CadastroProfissionalPublico from '@/views/Pages/CadastroProfissionalPublico'
import CatalogoProfissionalPublico from '@/views/Pages/CatalogoProfissionalPublico'
import VoluntarioPublico from '@/views/Pages/VoluntarioPublico'
import EscolaMinisterialPublico from '@/views/Pages/EscolaMinisterialPublico'
import AcaoSocialPublico from '@/views/Pages/AcaoSocialPublico'
import CadastroCriancaPublico from '@/views/Pages/CadastroCriancaPublico'



Vue.use(VueRouter)

const routes = [
  { name: 'home', path: '/home', component: Home, meta: { requiresAdmin: true } },
  { name: 'auth', path: '/login', component: Auth, meta: { requiresAdmin: false } },
  { name: 'eventos', path: '/eventos', component: Eventos, meta: { requiresAdmin: true } },
  { name: 'agenda', path: '/agenda', component: Agenda, meta: { requiresAdmin: true } },
  { name: 'inscricoes', path: '/inscricoes', component: Inscricoes, },
  { name: 'dispositivos', path: '/dispositivos', component: Dispositivos, meta: { requiresAdmin: true } },
  { name: 'landing', path: '/', component: Landing, meta: { requiresAdmin: false } },
  { name: 'criarconta', path: '/criar-conta', component: CriarConta, meta: { requiresAdmin: false } },
  { name: 'cadastromembro', path: '/cadastro-membro', component: CadastroMembro, meta: { requiresAdmin: false } },
  { name: 'linksigreja', path: '/links', component: LinksIgreja, meta: { requiresAdmin: false } },
  { name: 'minhaigreja', path: '/minhaigreja', component: MinhaIgreja, meta: { requiresAdmin: true } },
  { name: 'cadastroprofissional', path: '/cadastro-profissional', component: CadastroProfissionalPublico, meta: { requiresAdmin: false } },
  { name: 'catalogoprofissional', path: '/catalogo-profissional', component: CatalogoProfissionalPublico, meta: { requiresAdmin: false } },
  { name: 'voluntariar', path: '/voluntariar', component: VoluntarioPublico, meta: { requiresAdmin: false } },
  { name: 'escolaministerial', path: '/escola-ministerial', component: EscolaMinisterialPublico, meta: { requiresAdmin: false } },
  { name: 'acaosocial', path: '/acao-social', component: AcaoSocialPublico, meta: { requiresAdmin: false } },
  { name: 'cadastrocrianca', path: '/cadastro-crianca', component: CadastroCriancaPublico, meta: { requiresAdmin: false } },
  { name: 'about', path: '/about', component: About, meta: { requiresAdmin: false } },
  { name: 'painel', path: '/painel', component: Login, meta: { requiresAdmin: false } },
  { name: 'vigilantes', path: '/vigilantes', component: Vigilantes, meta: { requiresAdmin: true } },
  { name: 'convocacao', path: '/convocacao', component: Convocacao, meta: { requiresAdmin: true } },
  { name: 'associarqrcode', path: '/associarqrcode', component: AssociarQRCode, meta: { requiresAdmin: true } },
  { name: 'criaqrcode', path: '/criaqrcode', component: CriaQRCode, meta: { requiresAdmin: true } },
  { name: 'associarqrcodecheckin', path: '/associarqrcodecheckin', component: AssociarQRCodeeCheckin, meta: { requiresAdmin: true } },
  { name: 'divulgador', path: '/divulgador', component: Divulgador, meta: { requiresAdmin: true } },
  { name: 'listaindicacoes', path: '/listaindicacoes', component: ListaIndicacoes, meta: { requiresAdmin: true } },
  { name: 'transacoes', path: '/transacoes', component: Transacoes, meta: { requiresAdmin: true } },
  { name: 'liberdade', path: '/liberdade', component: IgrejadaLiberdade, meta: { requiresAdmin: false } },
  { name: 'relrede', path: '/relrede', component: RelRede, meta: { requiresAdmin: true } },
  { name: 'relcelula', path: '/relcelula', component: RelCelula, meta: { requiresAdmin: true } },
  { name: 'relmembros', path: '/relmembros', component: RelMembros, meta: { requiresAdmin: true } },
  { name: 'relliderrede', path: '/relliderrede', component: RelLiderRede, meta: { requiresAdmin: true } },
  { name: 'relsupervisor', path: '/relsupervisor', component: RelSupervisor, meta: { requiresAdmin: true } },
  { name: 'rellidercelula', path: '/rellidercelula', component: RelLiderCelula, meta: { requiresAdmin: true } },
  { name: 'relmembroskids', path: '/relmembroskids', component: RelMembrosKids, meta: { requiresAdmin: true } },
  { name: 'relministerios', path: '/relministerios', component: RelMinisterios, meta: { requiresAdmin: true } },
  { name: 'liberdadeeb', path: '/liberdadeeb', component: LiberdadeEB, meta: { requiresAdmin: false } },
  { name: 'igrejadaliberdade', path: '/igrejadaliberdade', component: LinksLiberdade, meta: { requiresAdmin: false } },
  { name: 'voluntario', path: '/voluntario', component: Voluntario, meta: { requiresAdmin: false } },
  { name: 'voluntarios', path: '/voluntarios', component: Voluntarios, meta: { requiresAdmin: true } },
  { name: 'liberdadeem', path: '/liberdadeem', component: LiberdadeEM, meta: { requiresAdmin: false } },
  { name: 'liberdadeprofissionais', path: '/liberdadeprofissionais', component: CadastroProfissionais, meta: { requiresAdmin: false } },
  { name: 'liberdadecatalogo', path: '/liberdadecatalogo', component: CatalogoProfissionais, meta: { requiresAdmin: false } },
  { name: 'il', path: '/il', component: IL, meta: { requiresAdmin: false } },
  { name: 'ilkids', path: '/ilkids', component: ILKids, meta: { requiresAdmin: false } },
  { name: 'membroturma', path: '/membroturma', component: MembroTurma, meta: { requiresAdmin: true } },
  { name: 'checkin', path: '/checkin', component: CheckinMembroTurma, meta: { requiresAdmin: false } },
  { name: 'ilebkids', path: '/ilebkids', component: ILEBKids, meta: { requiresAdmin: false } },
  { name: 'escolabiblica', path: '/escolabiblica', component: EscolaBiblica, meta: { requiresAdmin: true } },
  // { name: 'iledkids', path: '/iledkids', component: ILEDKids, meta: { requiresAdmin: false } },
  { name: 'edkids', path: '/edkids', component: EncontroComDeus, meta: { requiresAdmin: true } },
  { name: 'relturma', path: '/turmas', component: RelTurma, meta: { requiresAdmin: true } },
  { name: 'programa', path: '/programa', component: Programa, meta: { requiresAdmin: true } },
  { name: 'beneficiario', path: '/beneficiario', component: Beneficiario, meta: { requiresAdmin: true } },
  { name: 'liberdadesocial', path: '/liberdadesocial', component: LiberdadeSocial, meta: { requiresAdmin: false } },
  { name: 'igrejas', path: '/igrejas', component: Igrejas, meta: { requiresAdmin: true } },
  { name: 'liberdadercad', path: '/liberdadercad', component: liberdadeRCad, meta: { requiresAdmin: false } },
  { name: 'relprofissionais', path: '/relprofissionais', component: RelProfissionais, meta: { requiresAdmin: true } },
  { name: 'servicos', path: '/servicos', component: Servicos, meta: { requiresAdmin: true } },
  { name: 'historico', path: '/historico', component: Historico, meta: { requiresAdmin: true } },
  { name: 'auditoria', path: '/auditoria', component: Auditoria, meta: { requiresAdmin: true } },

]

/* const router = new VueRouter({
  routes
}) */

const router = new VueRouter({
  mode: 'history',
  routes
})

//Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey)

  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const user = JSON.parse(json)
    if (user === "GERENTE" || user === "ADMIN" || user === "KIDS" || user === 'EVENTO' || user === 'LIDER' ||  user === 'BACKUP')
      next()
    else
      next({ path: '/' })
  } else {
    next()
  }
})

export default router
